export default __webpack_public_path__ + "static/media/maza-aaya.e0c5af3c.gif";